"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _traffic = require("@site/pattern-library-utils/traffic");
var _useScriptInjector = require("@site/pattern-library-utils/hooks/useScriptInjector");
const STATUS_ATTR_ID = 'data-status';
const useOpenModalOnLoad = options => {
  const {
    modalOpen = false,
    eid = '',
    scriptUrl = '',
    source = '',
    sourceApp = '',
    handleOpenModalClick = () => {}
  } = options || {};
  (0, _react.useEffect)(() => {
    if (!modalOpen) return;
    const scriptDoc = document.querySelector(`script[src="${scriptUrl}"]`);
    if (!scriptDoc) {
      (0, _traffic.logEvent)({
        eid: `${eid}.no-script.error`,
        type: 'impression',
        properties: {
          source,
          sourceApp,
          error: 'Empty script'
        }
      });
      return;
    }
    let observer = null;
    // eslint-disable-next-line prefer-const
    let interval;
    // eslint-disable-next-line prefer-const
    let timeout;
    const cleanup = () => {
      observer?.disconnect();
      clearTimeout(timeout);
      clearInterval(interval);
    };
    const handleScriptReady = () => {
      handleOpenModalClick(true);
      cleanup();
    };
    const handleTimeout = () => {
      (0, _traffic.logEvent)({
        eid: `${eid}.timeout.error`,
        type: 'impression',
        properties: {
          source,
          sourceApp,
          error: 'Too long response(>20 sec)'
        }
      });
      cleanup();
    };
    const checkScriptReady = () => {
      const isReady = scriptDoc?.getAttribute(STATUS_ATTR_ID) === _useScriptInjector.SCRIPT_STATUS.READY;
      isReady && handleScriptReady();
      return isReady;
    };
    if (checkScriptReady()) {
      // run check if modal already loaded
      return;
    }
    interval = setInterval(checkScriptReady, 500);
    timeout = setTimeout(handleTimeout, 20000);
    if (scriptDoc) {
      observer = new MutationObserver(() => {
        if (scriptDoc?.getAttribute(STATUS_ATTR_ID) === _useScriptInjector.SCRIPT_STATUS.READY) {
          handleScriptReady();
        }
      });
      observer.observe(scriptDoc, {
        attributes: true,
        attributeFilter: [STATUS_ATTR_ID]
      });
    }
    return () => {
      cleanup();
    };
  }, [modalOpen]);
};
var _default = exports.default = useOpenModalOnLoad;